module.exports = __webpack_public_path__ + "img/4-8009.267211fd.png";